import React from 'react';
import { useSetAtom } from 'jotai';
import { modalAtom } from '../atoms';
import { AddComment } from './add-comment';
import { DeleteComment } from './delete-comment';
export const useReviewModal = () => {
  const setModal = useSetAtom(modalAtom);
  const addComment = (annotationId?: string) => {
    setModal({
      title: 'Add Comment',
      description: 'Select the comment level',
      component: ({
        onClose
      }: {
        onClose: () => void;
      }) => <AddComment onClose={onClose} annotationId={annotationId} />,
      isOpen: true
    });
  };
  const editComment = (commentId: number) => {
    setModal({
      title: 'Add Comment',
      description: 'Select the comment level',
      component: ({
        onClose
      }: {
        onClose: () => void;
      }) => <AddComment onClose={onClose} commentId={commentId} />,
      isOpen: true
    });
  };
  const deleteComment = (commentIds: number[]) => {
    setModal({
      title: 'Delete Comment',
      description: 'Are you sure you want to delete these comments ?',
      component: ({
        onClose
      }: {
        onClose: () => void;
      }) => <DeleteComment onClose={onClose} commentIds={commentIds} />,
      isOpen: true
    });
  };
  return {
    addComment,
    editComment,
    deleteComment
  };
};